import request from '@/utils/request'

/** 管理员登录（后端路由：/api/auth/admin-login） */
export function login(data) {
  return request.post('/auth/admin-login', data)
}

/** 获取当前用户信息（后端路由：/api/auth/user-info） */
export function getUserInfo() {
  return request.get('/auth/user-info')
}